// eslint-disable-next-line import/no-unresolved
import KeenSlider from 'https://cdn.skypack.dev/pin/keen-slider@v6.4.1-2bW5h7N5TLEKpP3hb61d/mode=imports,min/optimized/keen-slider.js' // https://keen-slider.io/docs

class CollectionListCarousel extends window.BAO.CarouselElement {
  connectedCallback () {
    super.connectedCallback()
    this.carousel = this.initialiseCarousel()
  }

  initialiseCarousel () {
    if (!this.els?.slides?.exists || !this.els?.slide?.exists) return
    return new KeenSlider(this.els.slides.element, {
      selector: this.els.slide.selector,
      drag: true,
      loop: true,
      mode: 'free',
      rubberband: false,
      slides: {
        origin: 'auto',
        perView: 2,
        spacing: 2,
      },
      breakpoints: {
        '(min-width: 768px)': {
          slides: {
            perView: 2.5,
            spacing: 15,
          },
        },
      },
    })
  }
}

if (!customElements.get('collection-list-carousel')) {
  customElements.define('collection-list-carousel', CollectionListCarousel)
}
